/*
 * Pedestrian mode is on for a facility only when its Pinpad Access
 * configuration says so; every other hotel never sees pedestrian screens.
 * Walk-up PINs (a pedestrian PIN for a card tap-in with no booking) also need a
 * walk-up cap set — the same rule the API applies before issuing one.
 */
export const PINPAD_ACCESS_FEATURE = "Pinpad Access";
export const PINPAD_PROVIDER = "Inner Range";

function parseConfiguration(configuration) {
  if (typeof configuration !== "string") return configuration || null;
  try {
    return JSON.parse(configuration);
  } catch {
    return null;
  }
}

function pinpadConfiguration(facility) {
  return parseConfiguration(
    facility?.featureFacilityProviderConfigurations?.find(
      (item) =>
        item?.feature?.name === PINPAD_ACCESS_FEATURE &&
        item?.provider?.name === PINPAD_PROVIDER,
    )?.configuration,
  );
}

export function isPedestrianModeEnabled(facility) {
  return pinpadConfiguration(facility)?.pedestrian_mode === true;
}

export function isWalkupPinEnabled(facility) {
  return (
    isPedestrianModeEnabled(facility) &&
    Number(pinpadConfiguration(facility)?.walkup_pin_cap_hours) > 0
  );
}
